import { render, staticRenderFns } from "./VSuggestOffice.vue?vue&type=template&id=2db3998c&scoped=true"
import script from "./VSuggestOffice.vue?vue&type=script&lang=js"
export * from "./VSuggestOffice.vue?vue&type=script&lang=js"
import style0 from "./VSuggestOffice.vue?vue&type=style&index=0&id=2db3998c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db3998c",
  null
  
)

export default component.exports